import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { ContactsService } from '../../../shared/services/contact.service';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { IThreatAssessmentTeam } from '../../../shared/models/contact';

@Component({
  selector: 'case-assess-team-info',
  standalone: true,
  imports: [
    SpinnerComponent,
    CommonModule
  ],
  templateUrl: './case-assess-team-info.component.html',
  styleUrl: './case-assess-team-info.component.css'
})
export class CaseAssessTeamInfoComponent {

  @Input() caseId: string = '';
  @Output() onClose = new EventEmitter<void>();

  selectedContacts: IThreatAssessmentTeam[] = [];
  usersList: IThreatAssessmentTeam[] = [];
  currentUser: IThreatAssessmentTeam | null = null;
  currentBuildingId: string | null = null;
  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUser = this.userDataService.getCurrentUser();
    this.loadAssessUsers();
  };

  loadAssessUsers(): void {
    this.loading = true;
    if (this.currentBuildingId) {
      this.contactsService.getUsers(this.currentBuildingId).subscribe({
        next: (response) => {
          this.loading = false;

          const buildingId = Number(this.currentBuildingId);
          const email = this.currentUser?.email || '';
          const isInternalUser = email.endsWith('@nside.io');
          const isInternalBuilding = buildingId === 130 || buildingId === 316;

          // Filter users if currentBuildingId is NOT 130, remove all users with email ending in '@nside.io'
          if (!isInternalUser && !isInternalBuilding) {
            this.usersList = response.filter(
              (user: any) => !user.email.endsWith('@nside.io')
            );
          } else {
            this.usersList = response;
          }
          console.log('Successfully fetching users:', this.usersList);
          this.loadThreatAssessmentTeamMembers();
        },
        error: (error) => {
          this.loading = false;
          console.error('Error fetching users:', error.message);
        },
      });
    }
  }

  loadThreatAssessmentTeamMembers(): void {
    this.loading = true;
    if (this.caseId) {
      this.contactsService.getThreatAssessmentTeam(this.caseId).subscribe({
        next: (res) => {
          this.loading = false;
          if (res.found != false) {
            this.selectedContacts = res.team
              .map((item: any) => this.usersList.find(contact => contact.user_id === item.user_id))
              .filter((contact: IThreatAssessmentTeam | undefined): contact is IThreatAssessmentTeam => contact !== undefined);
            console.log('Successfully fetching threat team:', this.selectedContacts);
          }
        },
        error: (err) => {
          this.loading = false;
        }
      });
    }
  }

  handleCloseTeam(): void {
    this.onClose.emit();
  }
}
